if (!customElements.get('costco-buttons')) {
  class CostcoButtons extends HTMLElement {
    constructor () {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }
    connectedCallback () {
      this.costco_buttons = this.querySelectorAll('.variant-costco-button');
      document.addEventListener('variant:change', this.handleVariantChange);
    }

    disconnectedCallback () {
      document.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleVariantChange (event) {
      const current_variant_id = event.detail.variant.id.toString();
      if (current_variant_id && this.costco_buttons) {
        this.costco_buttons.forEach(costco_button => {
          const costco_button_variant_id = costco_button.getAttribute('data-variant-id');
          if (costco_button_variant_id === current_variant_id) {
            costco_button.classList.remove('hidden');
          } else {
            costco_button.classList.add('hidden');
          }
        });
      }
    }
  }

  customElements.define('costco-buttons', CostcoButtons);
}